import { eventManager } from '~/utils/behavior/applicationEvents/event-manager';

export default {
  resetScrollTrigger({ commit }) {
    commit('RESET_SCROLL_TRIGGER');
  },

  /**
   * Pushes a scroll threshold reached event to GTM
   */
  setScrollTriggered({ commit, state }) {
    if (!state.hasTriggeredScroll) {
      commit('SET_SCROLL_TRIGGERED');

      const route = window?.$nuxt?.$route;

      const scrollData = {
        threshold: state.scrollThreshold,
        path: route?.path || '',
        title: route?.meta?.title || 'Skade',
      };

      eventManager.raiseScrollEvent(scrollData);
    }
  },
};
